export default __webpack_public_path__ + "static/hq4-04f756ab1d0bb92759977ff816a46dc5.jpg";